<template>
  <div
    class="subheader py-3 py-lg-8 subheader-transparent"
    v-bind:class="subheaderClasses"
    id="kt_subheader"
  >
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex align-items-baseline mr-5">
        <!--begin::Page Title-->
        <h2 class="subheader-title text-dark font-weight-bold my-2 mr-3">
          {{ title }}
        </h2>
        <!--end::Page Title-->
        <!--begin::Breadcrumb-->
        <!-- <ul
          class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold my-2 p-0"
        >
          <template v-for="(breadcrumb, i) in breadcrumbs">
            <li :key="`${i}-${breadcrumb.id}`" class="breadcrumb-item">
              <router-link
                :key="`${i}-${breadcrumb.id}`"
                v-if="breadcrumb.route"
                :to="breadcrumb.route"
                class="text-muted"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span
                class="text-muted"
                :key="`${i}-${breadcrumb.id}`"
                v-if="!breadcrumb.route"
              >
                {{ breadcrumb.title }}
              </span>
            </li>
          </template>
        </ul> -->
        <!--end::Breadcrumb-->
      </div>
      <!--begin::Toolbar-->
      <div class="d-flex align-items-center">
        <router-link
          :to="{ name: 'leaderboard' }"
          class="btn btn-fh btn-white btn-hover-primary font-weight-bold px-2 px-lg-5 mr-2"
        >
          <span class="svg-icon svg-icon-primary svg-icon-lg">
            <!--begin::Svg-->
            <inline-svg src="/media/svg/icons/Layout/Layout-horizontal.svg" />
            <!--end::Svg Icon-->
          </span>
          General Leaderboard
        </router-link>
        <router-link
          :to="{ name: 'document-qa' }"
          class="btn btn-fh btn-white btn-hover-primary font-weight-bold px-2 px-lg-5 mr-2"
        >
          <span class="svg-icon svg-icon-primary svg-icon-lg">
            <!--begin::Svg-->
            <inline-svg src="/media/svg/icons/Files/Selected-file.svg" />
            <!--end::Svg Icon-->
          </span>
          Document QA
        </router-link>
        <router-link
          :to="{ name: 'kie' }"
          class="btn btn-fh btn-white btn-hover-primary font-weight-bold px-2 px-lg-5 mr-2"
        >
          <span class="svg-icon svg-icon-primary svg-icon-lg">
            <!--begin::Svg-->
            <inline-svg src="/media/svg/icons/Communication/Chat1.svg" />
            <!--end::Svg Icon-->
          </span>
          Key Information Extraction
        </router-link>
        <router-link
          :to="{ name: 'table-qa' }"
          class="btn btn-fh btn-white btn-hover-primary font-weight-bold px-2 px-lg-5 mr-2"
        >
          <span class="svg-icon svg-icon-primary svg-icon-lg">
            <!--begin::Svg-->
            <inline-svg src="/media/svg/icons/Layout/Layout-grid.svg" />
            <!--end::Svg Icon-->
          </span>
          Table QA/NLI
        </router-link>
        <!-- <router-link
          :to="{ name: 'figure-qa' }"
          class="btn btn-fh btn-white btn-hover-primary font-weight-bold px-2 px-lg-5 mr-2"
        >
          <span class="svg-icon svg-icon-primary svg-icon-lg">
            <inline-svg src="/media/svg/icons/Shopping/Chart-pie.svg" />
          </span>
          Figure QA
        </router-link> -->
      </div>
      <!--end::Toolbar-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }

        if (this.layoutConfig("subheader.clear")) {
          classes.push("mb-0");
        }
      }
      return classes.join(" ");
    }
  }
};
</script>
